import React from 'react';
import { motion } from 'framer-motion';
import { CONFIG } from '../config/variables';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheck, FiArrowRight, FiClock } = FiIcons;

const Investment = () => {
  const scrollToPayment = () => {
    const element = document.getElementById('payment');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const inclusions = [
    'Custom-written copy for your trade',
    'SEO-ready structure for your area',
    'Mobile-first premium design',
    'Trust framework that removes doubt',
    'Clear CTA and enquiry flow',
    'Instant enquiry notification setup',
    'Review and refinement',
    'Launch and setup'
  ];

  return (
    <section id="investment" className="py-20 bg-gradient-to-br from-black to-gray-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
            Investment
          </h2>
          <p className="text-xl text-white/80 max-w-2xl mx-auto">
            Compare this to typical $1,500–$3,000 generic sites or the per-lead costs on marketplaces. This is a revenue asset, not an expense.
          </p>
        </motion.div>

        {/* Soft Scarcity Note */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="flex justify-center mb-8"
        >
          <div className="bg-blue-500/10 border border-blue-500/30 rounded-full px-4 py-2 flex items-center gap-2">
            <SafeIcon icon={FiClock} className="text-blue-400 w-4 h-4" />
            <p className="text-blue-200 text-xs font-semibold">
              We only build a limited number of pages per week to maintain quality.
            </p>
          </div>
        </motion.div>

        {/* Package Card */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
          className="bg-gradient-to-br from-blue-500/10 to-purple-500/10 backdrop-blur-sm border border-white/20 rounded-2xl p-8 mb-8 relative"
        >
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-white mb-2">
              Premium Trade Landing Page Package
            </h3>
            <p className="text-white/60 mb-4">Normally valued over $2,000+</p>
            <div className="text-center">
              <span className="text-4xl lg:text-5xl font-bold text-white">
                ${CONFIG.PACKAGE_PRICE_ONETIME}
              </span>
              <span className="text-white/60 ml-2">one-time</span>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-3 mb-8">
            {inclusions.map((item, index) => (
              <div key={index} className="flex items-center gap-3">
                <SafeIcon icon={FiCheck} className="w-5 h-5 text-green-400 flex-shrink-0" />
                <span className="text-white/80">{item}</span>
              </div>
            ))}
          </div>

          <div className="bg-white/5 border border-white/10 rounded-lg p-4 mb-6">
            <p className="text-white/80 text-center">
              <strong>Hosting and professional email included free for the first {CONFIG.ONGOING_STARTS_AFTER_MONTHS_FREE} months.</strong>
            </p>
            <p className="text-white/60 text-center mt-2">
              After {CONFIG.ONGOING_STARTS_AFTER_MONTHS_FREE} months: ${CONFIG.ONGOING_PRICE_MONTHLY} per month includes hosting, enquiry notifications, and {CONFIG.EMAIL_ADDRESSES_INCLUDED} email addresses.
            </p>
          </div>

          <div className="text-center mb-6">
            <p className="text-blue-300 font-medium">
              One average job can cover the entire build cost.
            </p>
          </div>

          <div className="text-center">
            <button
              onClick={scrollToPayment}
              className="w-full sm:w-auto bg-gradient-to-r from-blue-500 to-purple-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:from-blue-600 hover:to-purple-700 transition-all duration-200 shadow-xl hover:shadow-2xl transform hover:scale-105 flex items-center justify-center gap-2"
            >
              Start My Landing Page Enquiry
              <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
            </button>
          </div>

          <p className="text-[10px] text-white/30 text-center mt-6">
            * Once slots are filled, new builds roll to the following week.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Investment;